

const arrayStar = ["Elementos limpia-lava parabrisas delantero y trasero (incl. llenado de líquido) y luneta térmica.", "Desgaste de las pastillas y discos de freno traseros.", "Desgaste de las pastillas y discos de freno delanteros.", "Funcionamiento de luces, indicadores del cuadro, interruptores de puerta y bocina.", "Revisión del estado y presión de los neumáticos, incluyendo la rueda de repuesto.", "Filtro de polen del aire acondicionado.", "Filtro de aire de motor.", "Comprobación del estado de la batería con herramienta de diagnosis Midtronics.", "Filtro de aire.", "Desgaste de las pastillas y discos de freno traseros (si el vehículo los equipa)." ]

export default arrayStar;


 

